/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Layout_LabelInputs */



/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Transcript_Export_Layout_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_layout_label = /** @type {((inputs?: Transcript_Export_Layout_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Layout_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "it") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "es") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Layout")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Layout")
	return /** @type {LocalizedString} */ ("Layout")
});